<div *ngIf="migration; else creationTemplate">
  <div class="success">
    <mat-icon>done_outline</mat-icon>
    <span
      translate="add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/migration/success"
      [translateParams]="{ account: account }"></span>
  </div>
  <ng-container *ngIf="hasWarnings && whatsappCloudApiService.warnings?.length">
    <ul>
      <ng-container *ngFor="let warning of whatsappCloudApiService.warnings">
        <li>{{ warning.descriptionKey | translate }}</li>

        <ng-container
          *ngIf="warning.reason === WhatsappCloudApiWarningEnum.LIMITATIONS_WITH_TEMPLATES && warning.details?.length">
          <div *ngFor="let detail of warning.details" class="templates-section">
            <ng-container *ngIf="detail.template$ | async as template">
              <strong>{{ template.metadata.name }}</strong>
              <a [href]="template['url']" target="_blank"> &nbsp;<mat-icon>open_in_new</mat-icon> </a>
            </ng-container>
          </div>
        </ng-container>
      </ng-container>
    </ul>
  </ng-container>
</div>

<ng-template #creationTemplate>
  <div class="success">
    <mat-icon>done_outline</mat-icon>
    <span
      translate="add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/success"
      [translateParams]="{ account: account }"></span>
  </div>

  <div class="subtitle-2-line">
    <p>
      <span [innerHtml]="'add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/subtitle-2' | translate"></span>
      <mat-icon
        [matTooltip]="'add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/part-2-tooltip' | translate">
        help_outline
      </mat-icon>
      :
    </p>
  </div>

  <p [innerHtml]="'add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/description-2' | translate"></p>

  <div class="step-actions">
    <button
      mat-raised-button
      color="primary"
      (click)="goToAccount()"
      [disabled]="!alcmeonContextService.waCloudApiSettings?.data?.site_id">
      {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/next' | translate }}
    </button>
    <button
      mat-raised-button
      (click)="goToAccount()"
      [disabled]="!alcmeonContextService.waCloudApiSettings?.data?.site_id">
      {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/payment-line/next-2' | translate }}
    </button>
  </div>
</ng-template>
